import { render, staticRenderFns } from "./DialogAddPersonInCharge.vue?vue&type=template&id=6876b0ed&scoped=true"
import script from "./DialogAddPersonInCharge.vue?vue&type=script&lang=js"
export * from "./DialogAddPersonInCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876b0ed",
  null
  
)

export default component.exports